import { useSelector } from 'react-redux'
import TasksUI from '../../components/v2/tasks/TasksUI.jsx'
import useTasksLogic from '../../components/v2/tasks/useTasksLogic.js'
import PageLayout from '../../components/v2/layout/Page/index.jsx'

export default function Tasks({ isStaff = false }) {
	const role = useSelector((s) => s.auth.accountType)
	const logic = useTasksLogic(role)
	return (
		<PageLayout pageName="Tasks">
			<TasksUI {...logic} isStaff={isStaff} />
		</PageLayout>
	)
}
